export const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '40px',
  },
  text: {
    fontSize: '20px',
    color: '#000000',
    fontWeight: 600,
  },
  logosWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '64px',
    rowGap: '18px',

    [theme.breakpoints.up('sm')]: {
      columnGap: '92px',
      gridTemplateColumns: '1fr 1fr 1fr',
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    width: '150px',
    height: '33px',
  },
})
